<template>
  <!-- <div style="margin-top: 30%; text-align: center;">
        <a href="javascript:;" v-clipboard:copy="fpurl" v-clipboard:success="copy">点击复制文件下载链接</a>
        <br><br><br>
        <span style="font-size: 16px; color: red;text-align: center">复制成功后，请粘贴到手机浏览器<br/>地址栏中进行下载。</span>
  </div>-->
  <div>
    <!-- <c-pdf :pdfurl="fpurl"></c-pdf> -->
    <a :href="invoiceUrl || 'http://' + fpurl" target="_blank">预览</a>
    <iframe
      :src="invoiceUrl || 'http://' + fpurl"
      width="100%"
      height="100%"
      frameborder="1"
    ></iframe>
    <!-- <pdf ref="pdf" :src="fpurl"></pdf> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      fpurl: "fp.bwjf.cn/downInvoice/" + this.$route.query.jobId,
      showBox: false,
      invoiceUrl: this.$route.query.invoiceUrl,
    };
  },
  created() {
    let winW = document.documentElement.clientWidth;
    let loadingTask = PDFJS.getDocument(this.invoiceUrl);
    loadingTask.promise.then(
      function(pdf) {
        let pageNum = pdf.numPages;
        for (let i = 1; i <= pageNum; i++) {
          pdf.getPage(i).then(function(page) {
            let viewport = page.getViewport(1);
            let scale = (winW / viewport.width).toFixed(2);
            let scaledViewport = page.getViewport(scale);
            let canvas = document.getElementById("the-canvas" + i);
            let context = canvas.getContext("2d");
            canvas.height = scaledViewport.height;
            canvas.width = scaledViewport.width;
            let renderContext = {
              canvasContext: context,
              viewport: scaledViewport
            };
            let renderTask = page.render(renderContext);
            renderTask.then(function() {});
          });
        }
      },
      function(reason) {
        console.error(reason);
      }
    );
    // this.isAndroid();
  },
  methods: {
    is_weixin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        console.log("微信浏览器");
        return true;
      } else {
        console.log("不是微信浏览器");

        return false;
      }
    },

    download() {
      let is_weixin = this.is_weixin();
      if (is_weixin) {
        //是微信浏览器  显示返回按钮   （用户可以选择下载或者返回）
        return;
      } else {
        //不是微信浏览器
        //执行下载  fp.bwjf.cn/downInvoice/499247997dc146c59740198495af1a71
        // this.axios.get(fpurl + this.fpid).then(res => {
        //     console.log(res);
        // });
      }
    },
    isAndroid() {
      let u = navigator.userAgent;
      console.log(this.jobId);
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //安卓终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //苹果终端
      if (isAndroid) {
        //判断为安卓手机
        console.log("这是安卓手机");
        this.showBox = false;
      } else if (isIOS) {
        //判断为苹果手机
        console.log("这是苹果手机");
        this.showBox = true; //判断显示的是哪一个页面，我这边设置的就是如果为true就显示iOS的页面，如果为false就显示安卓的页面
      }
      this.download();
    },
    copy() {
      this.$toast("复制成功！");
    }
  }
};
</script>
